export enum TariffUpgradeType {
    PassportVerification = "passport_verification",
    PhoneCheckByBlackList = "phone_verification",
    SelfieVerification = "selfie_verification",
    SigningSms = "signing_sms",
    SigningWhatsapp = "signing_whatsapp",
    ContractLinkSms = "contract_link_sms",
}

export namespace TariffUpgradeType {
    export function getTitle(type: TariffUpgradeType | string): string {
        switch (type) {
            case TariffUpgradeType.PassportVerification:
            case "passport_verification":
                return "Проверка паспорта";
            case TariffUpgradeType.PhoneCheckByBlackList:
            case "phone_verification":
                return "Проверка телефона";
            case TariffUpgradeType.SelfieVerification:
            case "selfie_verification":
                return "Проверка селфи с паспортом";
            case TariffUpgradeType.SigningSms:
            case "signing_sms":
                return "SMS-код при подписании";
            case TariffUpgradeType.SigningWhatsapp:
            case "signing_whatsapp":
                return "WhatsApp-код при подписании";
            case TariffUpgradeType.ContractLinkSms:
            case "contract_link_sms":
                return "SMS со ссылкой на документ";
            default:
                return "";
        }
    }

    export const signerVerificationUpgrades = [
        TariffUpgradeType.PassportVerification,
        TariffUpgradeType.PhoneCheckByBlackList,
        TariffUpgradeType.SelfieVerification,
    ];

    export const signingCommunicationUpgrades = [
        TariffUpgradeType.SigningSms,
        TariffUpgradeType.SigningWhatsapp,
    ];

    export const contractLinkUpgrades = [
        TariffUpgradeType.ContractLinkSms,
    ];

    export const availableUpgrades = [
        ...signerVerificationUpgrades,
        ...signingCommunicationUpgrades,
        ...contractLinkUpgrades,
    ];

    /** WhatsApp-апгрейд пока только вне юрисдикции РФ (см. API funcs/jurisdiction.py). */
    export function isSigningWhatsappAvailable(jurisdiction?: string | null): boolean {
        const code = (jurisdiction || 'RU').toString().trim().toUpperCase() || 'RU'
        return code !== 'RU'
    }

    export function signingCommunicationUpgradesForJurisdiction(
        jurisdiction?: string | null,
    ): TariffUpgradeType[] {
        if (isSigningWhatsappAvailable(jurisdiction)) {
            return [...signingCommunicationUpgrades]
        }
        return signingCommunicationUpgrades.filter(
            (upgrade) => upgrade !== TariffUpgradeType.SigningWhatsapp,
        )
    }

    export function availableUpgradesForJurisdiction(
        jurisdiction?: string | null,
    ): TariffUpgradeType[] {
        return [
            ...signerVerificationUpgrades,
            ...signingCommunicationUpgradesForJurisdiction(jurisdiction),
            ...contractLinkUpgrades,
        ]
    }
} 